<div class="body-2" [ngStyle]="asignaEstiloBody()">
  <div class="sign-up-wrap smallw">
    <div class="divusr">
      <div class="divizquierdausr ocultarmediumw">
      </div>
      <div class="divfotousr">
        <img [src]="srcLogo" loading="lazy" alt="" class="fotousr">
      </div>
      <div class="divdetalleusr">
        <h4 class="colortituloingreso">Crear una nueva empresa (llenar todos los datos)</h4>
      </div>
      <div class="divizquierdausr ocultarmediumw">
        <p class="ppegadoabajo">
          <a>.</a>
        </p>
      </div>
    </div>
    <div class="seccionusr wf-section">
      <div class="divusr">
        <div class="divdetalleusr">
          <h5 class="colortituloingreso">Usuario que solicita la creación:</h5>
          <h5 class="colortituloingreso">{{userAutActual.nombre}} ({{userAutActual.email}})</h5>
        </div>
        <div class="divdetalleusr">
          <div class="w-form">
            <form [formGroup]="formNuevaEmp" (ngSubmit)="nuevaEmpSubmit()" #nuevaEmpForm="ngForm" id="nuevaEmp-form"
              name="nuevaEmp-form" data-name="Formulario de nuevaEmp">
              <div class="lineadetusrped ldup60vw">
              </div>
              <p class="ppegadoabajo">
                <a class="colortextoingreso">Nombre de la empresa:</a>
              </p>
              <div class="lineadetusrped">
                <input type="text" formControlName="fTxtNombre" [ngStyle]="asignaEstilo(formNuevaEmp, 'fTxtNombre')"
                  name="fTxtNombre" data-name="fTxtNombre" id="fTxtNombre" required="" placeholder="Nombre"
                  class="text_field w-input" minlength="3" maxlength="256">
              </div>
              <p class="ppegadoabajo">
                <a class="colortextoingreso">RUC:</a>
              </p>
              <div class="lineadetusrped">
                <input type="text" formControlName="fTxtRUC" [ngStyle]="asignaEstilo(formNuevaEmp, 'fTxtRUC')"
                  name="fTxtRUC" data-name="fTxtRUC" id="fTxtRUC" required="" placeholder="RUC"
                  class="text_field w-input" minlength="3" maxlength="256">
              </div>
              <div class="lineadetusrped">
                <label class="w-checkbox">
                  <input type="checkbox" formControlName="fChkAcepto" name="fChkAcepto" data-name="fChkAcepto"
                    id="fChkAcepto" class="w-checkbox-input">
                  <span class="checkbox-label w-form-label">
                    <p class="colortextoingreso">He leído y acepto los <a routerLink="/sitio-publico/terminos"
                        class="link">Términos de Uso y Política de Privacidad</a>
                    </p>
                  </span>
                </label>
              </div>
              <p class="ppegadoabajo">
                <a class="colortextoingreso">.</a>
              </p>
              <h4 *ngIf="mensajeRegistro!==''" class="coloralertaingreso">{{mensajeRegistro}}</h4>
              <h4 *ngIf="mensajeRegistro2!==''" class="coloralertaingreso">{{mensajeRegistro2}}</h4>
              <div class="columns-7 w-row">
                <div class="w-col w-col-6">
                  <input type="submit" [disabled]="!formNuevaEmp.valid"
                    [ngStyle]="asignaEstiloSubmitDisabled(formNuevaEmp)" value="Crear Empresa"
                    data-wait="Un momento, por favor..." id="fBtnCrear" class="button w-button smallw">
                </div>
                <div class="w-col w-col-6">
                  <input type="submit" routerLink="/sitio-publico/inicio" value="Salir"
                    data-wait="Un momento, por favor..." id="fBtnSalir" class="button w-button smallw">
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>